import React, { MouseEventHandler, useEffect, useState } from 'react'
import { clearWizardState } from "../utils/localStorage";
import { render } from 'react-dom';
import axios from 'axios';
import { RegExpMatchArrayWithGroups } from '../types/WigWizard'
import { User } from '../types/User';
import { WigRemovalPopup } from '../components/WigRemovalPopup';

(function init() {
  const selectors = {
    accountTemplate: '.template-account',
    logoutButton: '[data-logout-button]',
    savedWigSection: '[data-section-saved-wigs]',
  }

  const accountTemplate = document.querySelector<HTMLElement>(selectors.accountTemplate);
  const savedWigSectionElement = document.querySelector<HTMLElement>(selectors.savedWigSection);

  if (!accountTemplate) return


  document.querySelectorAll(selectors.logoutButton).forEach(button => {

    button.addEventListener('click', async () => {
      await axios.post('/cart/clear.js')
      clearWizardState()
      location.href = '/account/logout'
    })
  })

  render(<SavedWigStyles />, savedWigSectionElement)
})()

function SavedWigStyles() {
  const [skuArr, setSkuArr] = useState<any>([]);
  const [wigImagesArr, setWigImagesArr] = useState<any[]>([]);
  const [styleToDelete, setStyleToDelete] = useState('');

  const selectors = {
    wigs: '[data-saved-wigs]',
    userData: '[data-customer-data]',
  }

  const wigsElement = document.querySelectorAll<HTMLElement>(selectors.wigs);
  const user: User = JSON.parse(document.querySelector(selectors.userData).innerHTML)

  const dateOptions: any = {
    month: '2-digit',
    day: 'numeric',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  };

  useEffect(() => {
    const arrSku = [];

    wigsElement.forEach(wigSku => {
      const regexp = /products\/(?<product>[^\?]+)/gm.exec(wigSku.dataset.wigUrl) as RegExpMatchArrayWithGroups;
      const handle = regexp[1].replace(/\-/g, ' ');
      const date = new Date(wigSku.dataset.wigDate).toLocaleDateString("en-US", dateOptions);

      arrSku.push({
        sku: wigSku.dataset.wigSku,
        url: wigSku.dataset.wigUrl,
        date,
        handle
      })
      arrSku.sort((a, b) => new Date(a.date) < new Date(b.date) ? 1 : -1)
    })

    setSkuArr(arrSku);
  }, [])

  useEffect(() => {
    async function getImage() {
      const skus = skuArr.map((wig: any) => {
        const searchParams = new URLSearchParams(wig.url);
        const shade = searchParams.get('shade');

        return axios.post('https://6eqmfkewa4.execute-api.us-east-1.amazonaws.com/image-provider-devel', {
          sku: wig.sku,
          model: shade
        })
      })

      const response = await Promise.all(skus);
      setWigImagesArr(response);
    }

    getImage();
  }, [skuArr])

  function buttonAction() {
    location.reload()
  }

  function showPopup(event: React.MouseEvent<HTMLDivElement, MouseEvent>, url: string) {
    event.preventDefault()
    event.stopPropagation()
    const searchParams = new URLSearchParams(url);
    const id = searchParams.get('styleId');
    setStyleToDelete(id)
  }

  return <div id="saved-styles" className="relative flex w-full overflow-x-scroll whitespace-nowrap gap-4 pb-2">
    {styleToDelete &&
      <WigRemovalPopup user={user} id={styleToDelete} buttonAction={buttonAction} close={() => setStyleToDelete('')} />
    }
    {wigImagesArr.map((wig, index) => {
      return <a className="bg-white drop-shadow-cartItem" href={skuArr[index].url}>
        <div title="Click to delete this style from your profile" onClick={(event) => showPopup(event, skuArr[index].url)} className="absolute left-2 top-2 z-10">
          <svg width="19" height="25" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.81053 0H3.63684C3.50699 0.00223351 3.3832 0.055253 3.29208 0.147662C3.20095 0.240071 3.14978 0.364493 3.14954 0.494183V1.66331H0.495659C0.364792 1.66551 0.239912 1.71845 0.147416 1.81092C0.0549203 1.9034 0.00205666 2.02816 0 2.15885V4.24687C0 4.51409 0.228069 4.71774 0.495659 4.71774H0.819698L1.50085 14.5379C1.51844 14.7916 1.72961 15 1.98421 15H9.46313C9.71776 15 9.9289 14.7916 9.94652 14.5379L10.6277 4.71774H10.9518C11.2193 4.71774 11.4474 4.51409 11.4474 4.24687V2.15885C11.4453 2.02816 11.3924 1.9034 11.3 1.81092C11.2075 1.71845 11.0826 1.66551 10.9517 1.66331H8.29783V0.494183C8.2976 0.364491 8.24642 0.240065 8.1553 0.147654C8.06418 0.0552428 7.94038 0.00222578 7.81053 0ZM4.11863 0.967742H7.32874V1.66331H4.11863V0.967742ZM9.01105 14.0323H2.43638L1.79109 4.71774H9.65628L9.01105 14.0323ZM10.4783 3.75H0.969089V2.63105H10.4783V3.75Z"
              fill="black" />
            <path d="M7.49964 6.31592H6.31543V12.237H7.49964V6.31592Z" fill="black" />
            <path d="M5.13148 6.31592H3.94727V12.237H5.13148V6.31592Z" fill="black" />
          </svg>
        </div>

        <img className="lazyload max-w-[234px]" src={wig?.data.image} />
        <div className="p-5">
          <div className="text-center">
            <p className="text-xs md:text-sm">
              <span>Saved </span>
              <span className="capitalize font-medium">{skuArr[index].date}</span>
            </p>
          </div>
          <button className="uppercase bg-black text-white block text-center text-sm p-2.5 mt-5 w-full">Edit this look</button>
        </div>
      </a>
    })}
  </div>
}
